<template>
  <div class="display-version">
    <div class="display-version__app">License Manager v{{ getVersion }}</div>
    <div class="display-version__copyright">
      Copyright <a href="https://kiratik.de" target="_blank" rel="noopener" class="display-version__link">KIRATIK</a> GmbH {{ currentYear }}
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import packageJson from '../../../package.json';

export default Vue.extend({
  computed: {
    getVersion() {
      return packageJson.version;
    },
    currentYear() {
      return new Date().getFullYear();
    },
  },
});
</script>

<style scoped>
.display-version {
  text-align: center;
}

.display-version__app,
.display-version__copyright {
  font-size: 12px;
  color: #757575;
}

.display-version__link {
  color: inherit;
  text-decoration: none;
  transition: color 0.2s;
}

.display-version__link:hover {
  color: #005572;
}
</style>
